import { lazy } from 'solid-js'
import { messages } from '../../pages/vertoflex-page/vertoflex-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/vertoflex-page/vertoflex-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/vertoflex',
    titleMessage: messages.titleMessage,
}
